import "./App.css";
import { Toaster } from "react-hot-toast";
import AppRoutes from "./routes";
import { CssBaseline } from "@mui/material";

function App() {
  return (
    <>
      <CssBaseline />
      <Toaster />
      <AppRoutes />
    </>
  );
}

export default App;
